<script setup lang="ts">
  import { DialogTrigger, type DialogTriggerProps } from "reka-ui"

  const props = defineProps<DialogTriggerProps>()
</script>

<template>
  <DialogTrigger v-bind="props" data-testid="dialog-trigger">
    <slot />
  </DialogTrigger>
</template>
